import React from 'react';
import { getOfferStatusKey } from '../../utils/offers';

const STATUS_CLASSES = {
  submitted:
    'bg-primary-50 text-primary-700 border-primary-200 dark:bg-primary-900/20 dark:text-primary-200 dark:border-primary-800/40',
  viewedByPartner:
    'bg-primary-100 text-primary-800 border-primary-300 dark:bg-primary-900/30 dark:text-primary-200 dark:border-primary-700/40',
  contacted:
    'bg-primary-200/60 text-primary-800 border-primary-300 dark:bg-primary-900/40 dark:text-primary-100 dark:border-primary-600/40',
  closed: 'bg-primary-100 text-primary-800 border-primary-200 dark:bg-slate-800 dark:text-primary-200 dark:border-slate-700',
};

export const InterestStatusBadge = ({ status, t, className = '' }) => {
  const key = getOfferStatusKey(status);

  return (
    <span
      className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] ${
        STATUS_CLASSES[key] || STATUS_CLASSES.submitted
      } ${className}`}
    >
      {t(`offers.statuses.${key}`)}
    </span>
  );
};

export default InterestStatusBadge;
